import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['category', 'checkbox'];

  connect() {
    // Initialize selected categories from any already checked boxes
    this.checkboxTargets.forEach((checkbox) => {
      const categoryId = checkbox.dataset.categoryId;
      const isChecked = checkbox.checked;
      const categoryElement = this.findCategoryElement(categoryId);

      if (categoryElement && isChecked) {
        this.toggleCategorySelected(categoryElement, true);
      }
    });
  }

  toggleCategory(event) {
    const categoryElement = event.currentTarget;
    const categoryId = categoryElement.dataset.categoryId;
    const checkbox = this.findCheckbox(categoryId);

    if (checkbox) {
      checkbox.checked = !checkbox.checked;
      this.toggleCategorySelected(categoryElement, checkbox.checked);
    }
  }

  toggleCategorySelected(categoryElement, isSelected) {
    if (isSelected) {
      categoryElement.classList.add('bg-pink-tags');
      categoryElement.classList.remove('bg-base-200');
      categoryElement.classList.add('border-pink-tags-stroke');
    } else {
      categoryElement.classList.remove('bg-pink-tags');
      categoryElement.classList.add('bg-base-200');
      categoryElement.classList.remove('border-pink-tags-stroke');
    }
  }

  findCategoryElement(categoryId) {
    return this.categoryTargets.find(
      (category) => category.dataset.categoryId === categoryId
    );
  }

  findCheckbox(categoryId) {
    return this.checkboxTargets.find(
      (checkbox) => checkbox.dataset.categoryId === categoryId
    );
  }
}
